import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ug-bachelor-of-science-computer-sciencen',
  templateUrl: './ug-bachelor-of-science-computer-sciencen.component.html',
  styleUrls: ['./ug-bachelor-of-science-computer-sciencen.component.scss']
})
export class UgBachelorOfScienceComputerSciencenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
